/**
 * How an arrival time reads in the stamp chip, the sheet and the offer modal —
 * the same words as the in-the-post route (`letters/eta.ts`), from the same
 * server-quoted `deliverAt`, so every ETA on screen agrees.
 */

import { arrivesPhrase } from '../letters/eta';

/** Chip copy: "tomorrow 9am", "Thursday 8am", "today 4:30pm". */
export function etaShort(iso: string, now: Date = new Date()): string {
  return arrivesPhrase(iso, now).replace(' at ', ' ');
}

/** Sheet and modal copy: "arrives tomorrow at 9am". */
export function etaLong(iso: string, now: Date = new Date()): string {
  return `arrives ${arrivesPhrase(iso, now)}`;
}
